import { TruncateString } from '../../../Public/Functions/TruncateString';
import { ButtonsTransaction } from '../../Form/Buttons/ButtonsTransaction';

export const User = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="name">lastname</div>
                    <div className="item">firstname</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                let name = TruncateString(el.lastname, 30);
                return (
                    <div key={`i-${i}`} className="rows">
                        <div className="block-rows">
                            <div className="id">{i + 1}</div>
                            <div className="name">{name}<span className="id">({el.id})</span></div>
                            <div className="item">{el.firstname}</div>
                        </div>
                        <ButtonsTransaction id={el.id} entity={entity} />
                    </div>
                )
            })}
        </div>
    )
} 